import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import StationModel from '@/models/StationModel'

import stationService from '@/services/station.service'

// -----------------------------------------------------------------------------

const state = {
    stations: {},
    isLoading: false,
}

const getters = {
    getStations: state => {
        return _orderBy(state.stations, item => Number(item.sort) || 0, ['asc'])
    },

    getStation: state => stationId => {
        return state.stations[stationId] || null
    },
}

const mutations = {
    setStations(state, payload) {
        state.stations = {}

        _forEach(payload, item => {
            const Station = new StationModel(item)

            Vue.set(state.stations, Station.id, Station)

            if (Station.city) {
                this.commit('city/setCity', {
                    id: Station.city,
                    name: Station.city,
                    sort: Station.sort,
                })
            }
        })
    },

    setStation(state, payload) {
        const Station = new StationModel(payload)

        Vue.set(state.stations, Station.id, Station)
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

const actions = {
    fetch({ commit }) {
        commit('setIsLoading', true)
        return new Promise((resolve, reject) => {
            stationService.getList()
                .then(response => {
                    commit('setStations', response.response.items)
                    commit('setIsLoading', false)

                    resolve()
                })
                .catch(error => {
                    reject(error)
                })
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
